import Odometer from 'react-odometerjs'

export default Odometer
